import type { ReactNode } from "react";

import { Menu, MenuItem } from "react-aria-components";
import { useController, useFormContext } from "react-hook-form";

import { SelectBase } from "../select-base";

import styles from "./select-input.module.css";

type SelectOption = {
	icon?: ReactNode;
	id: string;
	label: string;
};

type SelectInputProps = {
	className?: string;
	description?: string;
	disabledKeys?: readonly string[];
	isDisabled?: boolean;
	isReadOnly?: boolean;
	label: string;
	name: string;
	options: readonly SelectOption[];
	placeholder: string;
};

export function SelectInput({
	className,
	description,
	disabledKeys,
	isDisabled,
	isReadOnly,
	label,
	name,
	options,
	placeholder,
}: SelectInputProps): ReactNode {
	const { control } = useFormContext();
	const { field, fieldState } = useController({ control, name });

	const selected = options.find((option) => {
		return option.id === field.value;
	});

	return (
		<SelectBase
			className={className}
			description={description}
			errorMessage={fieldState.error?.message}
			isDisabled={isDisabled}
			isInvalid={Boolean(fieldState.error)}
			isReadOnly={isReadOnly}
			label={label}
			onChange={field.onChange}
			placeholder={placeholder}
			value={selected?.label}
		>
			{(updateValue) => {
				return (
					<Menu className={styles.menu} disabledKeys={disabledKeys}>
						{options.map((option) => {
							return (
								<MenuItem
									className={styles.option}
									id={option.id}
									key={option.id}
									onAction={() => {
										return updateValue(option.id);
									}}
								>
									{option.icon && (
										<span className={styles.icon}>{option.icon}</span>
									)}
									{option.label}
								</MenuItem>
							);
						})}
					</Menu>
				);
			}}
		</SelectBase>
	);
}
